import { inject, Injectable, signal } from "@angular/core";
import { DbService } from "./db.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { formatISO } from "date-fns";
import { environment } from "../../environments/environment";
import { lastValueFrom } from "rxjs";

// noinspection JSVoidFunctionReturnValueUsed
@Injectable({
  providedIn: "root",
})
export class AuthService {
  private db = inject(DbService);
  private http = inject(HttpClient);

  constructor() {}

  getSession = (): any => {
    return this.db.remoteDB.getSession((error, result) => {
      if (error) {
        console.log(error);
        return error;
      } else if (!result?.userCtx.name) {
        console.log("no user logged in to couchdb");
        return null;
      } else {
        return result;
      }
    });
  };

  getCurrentUser = async () => {
    const session = await this.db.get("session");

    if (!(session as any).error) {
      const user = atob((session as any).session).split(":")[0];

      return user;
    } else {
      return null;
    }
  };

  signUpToCouchDB = async (
    credential: { email: string; password: string },
    userData: any,
  ) => {
    // Construct the user ID and document
    const userId = `org.couchdb.user:${credential.email}`;
    const userDoc = {
      _id: userId,
      name: credential.email,
      password: credential.password,
      roles: [], // Empty roles array by default
      type: "user",
      metadata: {
        email: userData.email,
        email_verified: userData.email_verified,
        full_name: userData.name,
        sub: userData.sub,
        registered_at: formatISO(new Date()),
      },
    };

    // Encode admin credentials for Basic Auth
    const adminAuth = btoa(
      `${environment.COUCHDB.ADMIN_NAME}:${environment.COUCHDB.PASSWORD}`,
    );
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Basic ${adminAuth}`,
    });

    try {
      // Make the PUT request to create the user
      const response = await lastValueFrom(
        this.http.put(`${environment.COUCHDB.URL}/_users/${userId}`, userDoc, {
          headers,
        }),
      );
      console.log("User created successfully:", response);
      return response;
    } catch (error) {
      console.error("Signup failed:", error);
      throw error;
    }
  };

  loginToCouchDB = async (
    credential: { email: string; password: string },
    user: any,
  ) => {
    try {
      const response = await this.db.remoteDB.logIn(
        credential.email,
        credential.password,
      );
      const session = btoa(credential.email + ":" + credential.password);
      this.db.upsert("session", { session: session });
      return response;
    } catch (error) {
      try {
        await this.signUpToCouchDB(credential, user);
        const response: any = await this.loginToCouchDB(credential, user);
        return response;
      } catch (signupError) {
        throw signupError;
      }
    }
  };

  logout = async () => {
    try {
      // Log out from CouchDB
      await this.db.remoteDB.logOut();

      // Remove the session from local storage
      await this.db.remove("session");

      // Clear any other stored data if needed
      await this.db.destroy();

      return true;
    } catch (error) {
      console.error("Logout failed:", error);
      throw error;
    }
  };
}
